import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';

interface AlertDialogProps {
    title: string;
    content_text?: string;
    submit_text?: string;
    onSubmit: (value: boolean) => void;
    submit_text_color?: string;
    cancal_text?: string;
    alertDialogOpen: boolean;
    setAlertDialogOpen: (value: boolean) => void;
    onCancel?: (value: boolean) => void;
}

export default function AlertDialog(props: AlertDialogProps) {

    const handleClose = () => {
        props.setAlertDialogOpen(false);
    };

    const clickHandleClose = () => {
        props.setAlertDialogOpen(false);
        props.onSubmit(false);
    };

    return (
        <div>
            <Dialog
                open={props.alertDialogOpen}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <DialogTitle id="alert-dialog-title">
                        {props.title}
                    </DialogTitle>
                    <div style={{ padding: "10px 16px 2px 16px" }}>
                        <p onClick={handleClose} style={{ cursor: "pointer" }}>
                            <CloseIcon />
                        </p>
                    </div>
                </div>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {props.content_text}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={props.onCancel ? () => props.onCancel(true) : clickHandleClose}
                    >
                        {props.cancal_text ? props.cancal_text : "No"}
                    </Button>
                    <Button
                        onClick={() => props.onSubmit(true)}
                        autoFocus
                        style={{ color: props.submit_text_color ? props.submit_text_color : "#1976d2" }}
                    >
                        {props.submit_text ? props.submit_text : "Yes"}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}